export enum UrlFilter {
  ALL = 0,
  WITH_ASINS = 1,
  WITHOUT_ASINS = 2,
  FAILED = 3,
}
